import { useEffect, useState } from 'react'
import { Stack, TextField, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import ButtonCustom from '../atoms/button/ButtonCustom'
import CommonModal from '../atoms/modal/CommonModal'
import { patchEventTags } from '../../features/guestListSlice'

export default function ManageEventTagsModal({
	open,
	onClose,
	kazooId,
	catalog = [],
}) {
	const dispatch = useDispatch()
	const [newTag, setNewTag] = useState('')
	const [submitting, setSubmitting] = useState(false)

	useEffect(() => {
		if (open) {
			setNewTag('')
			setSubmitting(false)
		}
	}, [open])

	const sortedCatalog = [...(catalog || [])].filter(Boolean).sort()

	const handleAdd = async () => {
		const tag = newTag.trim()
		if (!tag || submitting) return
		setSubmitting(true)
		try {
			await dispatch(patchEventTags({ kazooId, add: [tag] })).unwrap()
			setNewTag('')
		} catch {
			// toast handled in slice
		} finally {
			setSubmitting(false)
		}
	}

	const handleRemove = async (tag) => {
		if (submitting) return
		setSubmitting(true)
		try {
			await dispatch(patchEventTags({ kazooId, remove: [tag] })).unwrap()
		} catch {
			// toast handled in slice
		} finally {
			setSubmitting(false)
		}
	}

	return (
		<CommonModal
			open={open}
			handleClose={onClose}
			zIndex={2000}
			heading="Manage event tags"
			subHeading="Add or remove tags from the wedding catalog"
			data-cy="manage-event-tags-modal"
			footerContent={
				<ButtonCustom variant="outlined" size="lg" onClick={onClose}>
					Done
				</ButtonCustom>
			}
		>
			<Stack spacing={2}>
				<Typography variant="body2" color="text.secondary">
					Removing a tag updates the catalog and guest participation only; calendar
					events may keep the tag until edited.
				</Typography>

				<Stack direction="row" spacing={1} alignItems="center">
					<TextField
						size="small"
						fullWidth
						label="New tag"
						value={newTag}
						onChange={(e) => setNewTag(e.target.value)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								e.preventDefault()
								handleAdd()
							}
						}}
						disabled={submitting}
						inputProps={{ 'data-cy': 'manage-event-tag-add-input' }}
					/>
					<ButtonCustom
						variant="default"
						type="button"
						onClick={handleAdd}
						disabled={submitting || !newTag.trim()}
						data-cy="manage-event-tag-add"
					>
						Add
					</ButtonCustom>
				</Stack>

				<Stack spacing={1}>
					{sortedCatalog.length === 0 ? (
						<Typography variant="body2" color="text.secondary">
							No event tags yet.
						</Typography>
					) : (
						sortedCatalog.map((tag) => (
							<Stack
								key={tag}
								direction="row"
								spacing={1}
								alignItems="center"
								justifyContent="space-between"
							>
								<Typography>{tag}</Typography>
								<ButtonCustom
									variant="outlined"
									type="button"
									onClick={() => handleRemove(tag)}
									disabled={submitting}
									data-cy="manage-event-tag-remove"
								>
									Remove
								</ButtonCustom>
							</Stack>
						))
					)}
				</Stack>
			</Stack>
		</CommonModal>
	)
}
